<template>
    <div class="page-column">
        <Header />
        <MatchInfo />
        <MatchMenu />
        <MatchCompany />
        <MatchProject />
        <Footer />
    </div>
</template>

<script>
import Header from '@district/components/common/MatchHeader.vue'
import Footer from '@district/components/common/Footer'
import MatchInfo from '@comm/components/MatchInfo.vue'
import MatchMenu from '@comm/components/MatchMenu.vue'
import MatchCompany from '@comm/components/MatchCompany.vue'
import MatchProject from '@comm/components/MatchProject.vue'
export default {
  components: {
    Header,
    MatchInfo,
    MatchMenu,
    MatchCompany,
    MatchProject,
    Footer,
  },
  mounted () {
  },
}
</script>

<style lang="scss" scoped>
.page-column {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/district/views/project/components/Detail.vue